import type { SVGProps } from "react"

export const PanelIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" {...props}>
    <rect x="3.5" y="5" width="17" height="14" rx="1.5" strokeWidth="1.75" />
    <path d="M3.5 12h17M12 5v14M8 5v14M16 5v14" strokeWidth="1.5" />
  </svg>
)
